<template>
  <div>
    <el-dialog
      @close="close"
      @open="open"
      :title="title"
      :visible="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <el-form
        ref="formData"
        :model="form"
        :rules="rules"
        size="medium"
        label-width="104px"
        label-position="top"
      >
        <el-form-item label="币种" prop="coinType">
          <el-input
            v-model="form.coinType"
            placeholder="请输入币种"
            clearable
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="id" prop="id">
          <el-input
            v-model="form.id"
            placeholder="请输入id"
            clearable
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="上传图片" prop="img">
          <el-upload
            ref="img"
            :file-list="imgfileList"
            :action="imgAction"
            :before-upload="imgBeforeUpload"
          >
            <el-button size="small" type="primary" icon="el-icon-upload"
              >点击上传</el-button
            >
          </el-upload>
        </el-form-item>
        <el-form-item label="认购限额" prop="limitAmount">
          <el-input
            v-model="form.limitAmount"
            placeholder="请输入认购限额"
            clearable
            :style="{ width: '100%' }"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="最大认购数量" prop="maxAmount">
          <el-input
            v-model="form.maxAmount"
            placeholder="请输入最大认购数量"
            clearable
            :style="{ width: '100%' }"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="最小认购数量" prop="minAmount">
          <el-input
            v-model="form.minAmount"
            placeholder="请输入最小认购数量"
            clearable
            :style="{ width: '100%' }"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="预期年化收益率" prop="rate">
          <el-input
            v-model="form.rate"
            placeholder="请输入预期年化收益率"
            clearable
            :style="{ width: '100%' }"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="精度" prop="scale">
          <el-input
            v-model="form.scale"
            placeholder="请输入精度"
            clearable
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品总量" prop="total">
          <el-input
            v-model="form.total"
            placeholder="请输入产品总量"
            clearable
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>
        <!-- 利率规则 -->
        <el-row>
          <el-row>
            <p>利率规则</p>
          </el-row>
          <el-col :span="24">
            <el-form size="mini" lable-width="100px">
              <el-row :span="12" v-for="(item, key) in rateRuleList" :key="key">
                <el-form-item :label="key">
                  <el-input
                    v-model="rateRuleList[key]"
                    class="width-250"
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-form>
          </el-col>
        </el-row>

        <!-- 产品收益说明 -->
        <el-row>
          <el-row>
            <p>产品收益说明</p>
          </el-row>
          <el-col :span="24">
            <el-form size="mini" lable-width="100px">
              <el-row
                :span="12"
                v-for="(item, key) in interestTextList"
                :key="key"
              >
                <el-form-item :label="key">
                  <el-input
                    v-model="interestTextList[key]"
                    class="width-250"
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <!-- 标签列表 -->
        <el-row>
          <el-row>
            <p>标签列表</p>
          </el-row>
          <el-col :span="24">
            <el-form
              size="mini"
              lable-width="100px"
              v-for="(tagItem, index) in tagList"
              :key="index"
            >
              <el-row :span="12" v-for="(item, key) in tagItem" :key="key">
                <el-form-item :label="key">
                  <el-input v-model="tagItem[key]" class="width-250"></el-input>
                </el-form-item>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLanguages } from '@/utils/encrypt.js'
import { thousandSeparator, dateFormat } from '@/utils/encrypt.js'

export default {
  inheritAttrs: false,
  components: {},
  props: ['visible', 'currentId'],
  data() {
    return {
      form: {
        coinType: undefined,
        id: undefined,
        img: null,
        limitAmount: undefined,
        maxAmount: undefined,
        minAmount: undefined,
        rate: undefined,
        scale: undefined,
        total: undefined,
      },
      interestTextList: {
        en: '',
        es: '',
        hi: '',
        hk: '',
        jp: '',
        ko: '',
        ru: '',
        zh: '',
      },
      rateRuleList: {
        en: '',
        es: '',
        hi: '',
        hk: '',
        jp: '',
        ko: '',
        ru: '',
        zh: '',
      },
      tagList: [
        {
          en: '',
          es: '',
          hi: '',
          hk: '',
          jp: '',
          ko: '',
          ru: '',
          zh: '',
        },
      ],
      rules: {
        coinType: [],
        id: [
          //   {
          //     required: true,
          //     message: '请输入id',
          //     trigger: 'blur',
          //   },
        ],
        limitAmount: [
          {
            required: true,
            message: '请输入认购限额',
            trigger: 'blur',
          },
        ],
        maxAmount: [],
        minAmount: [],
        rate: [],
        scale: [],
        total: [],
      },
      imgAction: 'https://jsonplaceholder.typicode.com/posts/',
      imgfileList: [],
    }
  },
  computed: {
    ...mapState('financial', ['currentTreasure']),
    title() {
      return this.currentId ? '修改' : '新增'
    },
  },
  watch: {},
  created() {},
  mounted() {
    // this.tagList = getLanguages()
    // this.interestTextList = getLanguages()
    // this.rateRuleList = getLanguages()
  },
  methods: {
    ...mapActions('financial', [
      'saveCurrentTreasure',
      'getCurrentTreasure',
      'getStakingDetail',
      'stakingSubmit',
    ]),
    async open() {
      if (this.currentId) {
        const { code, data, msg } = await this.getCurrentTreasure({
          id: this.currentId,
        })
        if (code === 0) {
          this.interestTextList = data.interestText
          this.rateRuleList = data.rateRule
          this.tagList = data.tagList
          this.form = data
        } else {
          this.$message({
            type: 'error',
            message: msg,
          })
        }
      }
    },
    close() {
      this.$refs['formData'].resetFields()
      this.reset()
      this.$emit('update:visible', false)
    },

    //重置
    reset() {
      this.interestTextList = {
        en: '',
        es: '',
        hi: '',
        hk: '',
        jp: '',
        ko: '',
        ru: '',
        zh: '',
      }
      this.rateRuleList = {
        en: '',
        es: '',
        hi: '',
        hk: '',
        jp: '',
        ko: '',
        ru: '',
        zh: '',
      }
      this.tagList = [
        {
          en: '',
          es: '',
          hi: '',
          hk: '',
          jp: '',
          ko: '',
          ru: '',
          zh: '',
        },
      ]
    },
    handelConfirm() {
      this.$refs['formData'].validate((valid) => {
        if (!valid) return
        if (this.currentId) {
          this.form.id = this.currentId
        }
        const params = {
          ...this.form,
          interestText: this.interestTextList,
          rateRule: this.rateRuleList,
          tagList: this.tagList,
        }
        console.log(params, 'params')
        this.saveCurrentTreasure(params).then((res) => {
          console.log(res, 'res')
          if (res.code !== 0) {
            this.$message({
              type: 'error',
              message: res.msg,
            })
            return
          }
          this.$emit('success')
        })
        this.close()
      })
    },
    imgBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2
      if (!isRightSize) {
        this.$message.error('文件大小超过 2MB')
      }
      return isRightSize
    },
  },
}
</script>
<style>
.el-upload__tip {
  line-height: 1.2;
}
</style>
